import React from "react";
import "./SurgicalItems.scss";
// import AOS from "aos";
import "aos/dist/aos.css";

const SurgicalItems = () => {

  return (
    <div className="surgical-items">
      <div className="surgical-items__heading" data-aos="fade-up">
        Hi
      </div> 
    </div>
  );
};

export default SurgicalItems;
